// --------------------------------------------------------
// ACTIVATE/INACTIVATE MODAL - ActivateInactivateModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import Modal from '@mui/material/Modal'
import React from 'react'
import { BlueEditButton, GenericSolidButton, RedCancelButton } from '../UI/buttons/Button.styled'
import { H1, H2 } from '../UI/generalLayout/Layout.styled'
import { ReactComponent as Exclamation } from '../../assets/imgs/exclamation.svg'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { ModalContainer, ModalContentContainer, ButtonAreaContainer } from '../genericModal/GenericModal.styled'
import Colors from '../../constants/Colors'

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CANCEL MODAL INTERFACE
// --------------------------------------------------------

interface IActivateInactivateModal {
    visible: boolean;
    onCancel: any;
    onConfirmCancellation: any;
    isActivate: boolean;
    ativarButtonMsg: string;
    inativarButtonMsg: string;
    modalMsg: string;
}
/**
/**
 * A component that renders a Cancel modal.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ActivateInactivateModal = ({visible, onCancel, onConfirmCancellation, isActivate, modalMsg, inativarButtonMsg, ativarButtonMsg}: IActivateInactivateModal) => {
    // --------------------------------------------------------
    // CANCEL MODAL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo(); 

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <Modal
                open={visible}
            >
                <ModalContainer isMobile={isMobile}>
                    <ModalContentContainer isMobile={isMobile}>
                        <Exclamation />
                        {isMobile? <H2>{modalMsg}</H2> : <H1>{modalMsg}</H1> }
                        <ButtonAreaContainer style={{ marginTop: isMobile? 70 : 20 }}>
                            <div style={{ width: isMobile? '100%': '', marginRight: !isMobile? 24 : 0, marginBottom: isMobile? 12 : 0 }}>
                                {isActivate? (<RedCancelButton
                                    onClick={onCancel}
                                >
                                    Cancelar
                                </RedCancelButton>):
                                (<BlueEditButton onClick={onCancel}>
                                    Cancelar
                                </BlueEditButton>)}
                            </div>

                            {isActivate? (<GenericSolidButton
                                color={Colors.SPM600}
                                onClick={onConfirmCancellation}
                            >
                                {ativarButtonMsg}
                            </GenericSolidButton>):
                            (<GenericSolidButton 
                                color={Colors.cancel}
                                onClick={onConfirmCancellation}>
                                {inativarButtonMsg}
                            </GenericSolidButton>)}
                        </ButtonAreaContainer>
                    </ModalContentContainer>
                </ModalContainer>
            </Modal>
        </>
    )
    // --------------------------------------------------------
}

export default ActivateInactivateModal